/**
 * useMainSnap — Plan 05-12 Task 2.
 *
 * TanStack Query hook for GET /api/main/metrics/snap/:metricId.
 * Used by MainTrendTile for snap-backed tiles: MAIN-13..18/21.
 *
 * Only fires when `enabled` is true (caller gates by active tab).
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MainSnapResponse } from '@saledash/shared';

interface UseMainSnapOptions {
  /** Gate query to active tab (default: true) */
  enabled?: boolean;
  /** Days back window (default: 60 — ~8 weekly buckets) */
  daysBack?: number;
}

export function useMainSnap(
  metricId: string,
  { enabled = true, daysBack = 60 }: UseMainSnapOptions = {},
): UseQueryResult<MainSnapResponse> {
  return useQuery<MainSnapResponse>({
    queryKey: ['main', 'snap', metricId, daysBack],
    queryFn: ({ signal }) =>
      apiFetch<MainSnapResponse>(
        `/api/main/metrics/snap/${metricId}?daysBack=${String(daysBack)}`,
        { signal },
      ),
    enabled,
    staleTime: 5 * 60_000,
    retry: 2,
  });
}
